import { GetLayout } from '../../types';

import { NavigationComponent } from './NavigationComponent';
import { NextNavigationServiceOptions } from './types';

export const getLayoutFn =
  (layoutProps: NextNavigationServiceOptions = {}): GetLayout =>
  (page) =>
    <NavigationComponent {...layoutProps}>{page}</NavigationComponent>;
